import { render, staticRenderFns } from "./WebinaireCard.vue?vue&type=template&id=4c64332f&"
import script from "./WebinaireCard.vue?vue&type=script&lang=js&"
export * from "./WebinaireCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports